import {useEffect} from 'react';
import {Button, Modal, t, Textarea} from '@ultradent/components';
import {translationKeys as _} from '@/constants/translations';
import {FormikProvider, useFormik} from 'formik';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

export const RequestInformation = ( {description, isProcessing, error, isOpen, onSubmit, onClose} ) => {
    const formik = useFormik( {
        enableReinitialize: true,
        validate: values => {
            const errors = {};
            if ( !values.inquiry || values.inquiry.trim() === '' ) {
                errors.inquiry = t( _.researchStudiesPage.notify.inquiryRequired );
            }
            return errors;
        },
        onSubmit: values => {
            onSubmit( values.inquiry.trim() );
            return false;
        },
        initialValues: {
            inquiry: ''
        }
    } );

    useEffect( () => {
        if ( !isOpen ) {
            formik.resetForm();
        }
    }, [isOpen] );

    return (
        <Modal
            title={t( 'researchStudiesPage.label.requestInformation', _.researchStudiesPage.label.requestInformation )}
            size="md"
            onClose={onClose}
            isOpen={isOpen}>
            {error &&
                <div className="my-4 text-fail text-base leading-snug">
                    <h3 className="mb-2 font-medium text-sm">{t(
                        'researchStudiesPage.notify.inquirySubmissionFailed',
                        _.researchStudiesPage.notify.inquirySubmissionFailed )}</h3>
                </div>
            }
            <FormikProvider value={formik}>
                <div className="mb-6">
                    <p className="text-title">
                        {description}
                    </p>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <fieldset>
                        <Textarea
                            name="inquiry"
                            value={formik.values.inquiry}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.inquiry && formik.errors.inquiry}
                            label={t( 'researchStudiesPage.label.whatInfoAreYouLookingFor',
                                _.researchStudiesPage.label.whatInfoAreYouLookingFor )}
                            labelAppend={`(${t( 'label.required', _.label.required )})`}
                        ></Textarea>
                    </fieldset>
                    <div className="flex w-full justify-start">
                        <Button
                            type="submit"
                            disabled={isProcessing || !isEmptyOrNil( formik.errors )}
                            loading={isProcessing}>
                            {t( 'actionLabel.submit', _.actionLabel.submit )}
                        </Button>
                        <Button
                            type="button"
                            onClick={onClose}
                            className="button tertiary ml-4">
                            {t( 'actionLabel.cancel', _.actionLabel.cancel )}
                        </Button>
                    </div>
                </form>
            </FormikProvider>
        </Modal>
    )
};

RequestInformation.defaultProps = {
    isOpen: false,
    isProcessing: false,
    onClose: () => {},
    onSubmit: () => {},
    user: {
        userId: null
    },
    claimId: ''
}
